import { CheckoutView } from '../../CheckoutView';
import { PAYMENT_CONST } from './Payment.d';
import type { PaymentViewProps } from './Payment.d';

const PaymentView = ({ children }: PaymentViewProps) => (
  <CheckoutView testid={PAYMENT_CONST.TEST_ID}>{children}</CheckoutView>
);

export default PaymentView;
